<template>
	<div>
		<div>
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">雇主险管理-详情</div>
			<el-button
				style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
				@click="Return">返回</el-button>
			<!-- 主体 -->

			<div style="height:750px;background-color:white;margin:75px 40px 0 40px;overflow-x: hidden">

				<el-form label-width="300px">
					<el-row>
						<el-col :span="12">
							<el-form-item label="保单名称：" prop="name" style="margin-top:80px;width:80%">
								{{ruleForm.insurance_name}}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="投保账户：" prop="name" style="margin-top:80px;width:80%">
								{{ruleForm.insure_account}}
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="承保公司：" prop="region">{{ruleForm.company_id}}</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="生效时间：">{{ruleForm.start_date}} ~
								{{ruleForm.end_date}}
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="单价：" prop="name" style="width:80%">{{ruleForm.unit_price}}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="保费：" prop="name" style="width:80%">{{ruleForm.premium}}
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="保额：" prop="name" style="width:80%">{{ruleForm.insured_amount}}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="免赔额、比例：" prop="name" style="width:80%">{{ruleForm.proportion}}
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="承保公司联系人：" prop="name" style="width:80%">
								{{ruleForm.company_contacts}}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="承保公司联系电话：" prop="name" style="width:80%">
								{{ruleForm.company_telephone}}
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="保单扫描件：" prop="name" style="width:80%">
								<img :src="ruleForm.insurance_url">
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="其他附件：" prop="name" style="width:80%">

							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						
						<el-col :span="12">
							<el-form-item label="备注：" prop="name">{{ruleForm.remarks}}</el-form-item>
						</el-col>
						
					</el-row>

					<el-row>
						<el-col :span="24">
							<el-form-item label="适用范围：" prop="region">
								<el-row v-for="(item, index) in rangeListIndex" :key="index"
									style="margin-bottom: 20px;">
									<el-form :model="ruleForm.rangeList[index]" :rules="rangeRules" ref="rangeRuleForm">
										<el-col :span="12">
											{{$globals.group_name + '>' + ruleForm.rangeList[index].range}}
										</el-col>
										<el-col :span="4">
											{{ruleForm.rangeList[index].post_name}}
										</el-col>
										<el-col :span="4">
											{{ruleForm.rangeList[index].dataName != null && ruleForm.rangeList[index].dataName != '' ? ruleForm.rangeList[index].dataName : '不限'}}
										</el-col>
										<el-col :span="4">
											{{ruleForm.rangeList[index].gender != null && ruleForm.rangeList[index].gender != '' ? (ruleForm.rangeList[index].gender == '1' ? '男' : '女') : '不限'}}
										</el-col>
									</el-form>
								</el-row>
							</el-form-item>
						</el-col>
					</el-row>
					

				</el-form>

			</div>

		</div>
	</div>
</template>

<script>
	export default {
		props: ["ruleForm"],
		data() {
			return {
				rangeListIndex: 0
			};
		},
		methods: {
			Return() {
				this.$parent.Return();
			}
		},
		created() {},
		watch: {
			"ruleForm.rangeList"(newValue) {
				this.rangeListIndex = newValue.length;
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Gzxgl_edit.vue?70dd117f